import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./index.scss";
import { Button, Checkbox, Image, Input, Modal, Pagination, Radio } from "antd";
import { ControlOutlined } from "@ant-design/icons";
import { getRequest, postRequest } from "../../../api/http";
import placementOfficer from "../../../api/placementOfficer";
import toastr from "toastr";
import { Navigate, useNavigate } from "react-router-dom";
import defaultCompany from "../../../assets/images/icons/default-company.png";
import ErrorIcon from "../../../assets/images/icons/Pagenotfound.svg";
import { LoadingView } from "../../common";

function Employer({ eventId }) {
  const { Search } = Input;
  const [searchValue, setSearchValue] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState("all");
  const [employersData, setEmployersData] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [selectedEmployers, setSelectedEmployers] = useState([]);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false); // New state for confirmation modal
  const [actionType, setActionType] = useState(""); // New state to store the action type (approve/reject)
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();

  const showModal = () => {
    setModalVisible(true);
  };

  const toggleSelectEmployer = (employerId) => {
    setSelectedEmployers((prevSelected) => {
      if (prevSelected.includes(employerId)) {
        return prevSelected.filter((id) => id !== employerId);
      } else {
        return [...prevSelected, employerId];
      }
    });
  };

  const handleOk = () => {
    if (approvalStatus === "all") {
      setFilterValue("");
    } else {
      setFilterValue(approvalStatus.toUpperCase());
    }
    setModalVisible(false);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const onSearch = async (value) => {
    setSearchValue(value);
  };

  useEffect(() => {
    fetchEmployers();
  }, [eventId, searchValue, filterValue]);

  const fetchEmployers = async () => {
    try {
      setloading(true);
      const response = await getRequest(
        placementOfficer.getRegisteredEmployers(
          eventId,
          searchValue,
          filterValue
        )
      );
      if (response) {
        setloading(false);
      }
      setEmployersData(response.content);
      // Remove selected IDs that are no longer pending
      setSelectedEmployers((prev) =>
        prev.filter((id) =>
          response.content.some(
            (emp) => emp.id === id && emp.membershipStatus === "REQUEST"
          )
        )
      );
    } catch (error) {
      setloading(false);
      console.error("Error fetching employers:", error);
    }
  };

  const handleApproval = async (status) => {
    setActionType(status); // Set the action type for confirmation
    setConfirmModalVisible(true); // Show the confirmation modal
  };

  const handleSingleRejection = async (id, status) => {
    setActionType(status); // Set the action type for confirmation
    setSelectedEmployers([id]); // Select the single employer for rejection
    setConfirmModalVisible(true); // Show the confirmation modal
  };

  const confirmAction = async () => {
    const data = {
      userId: selectedEmployers,
      status: actionType,
    };
    try {
      await postRequest(placementOfficer.ApproveEmployer(eventId), data);
      const successMessage =
        actionType === "APPROVE"
          ? "The employer has been Approved Successfully"
          : "The employer has been Rejected Successfully";
      toastr.success(successMessage);
      fetchEmployers();
    } catch (error) {
      console.error("Error updating employer status:", error);
    } finally {
      setConfirmModalVisible(false);
    }
  };
  const handleAction = (status) => {
    if (selectedEmployers.length > 0) {
      if (status === "REJECT") {
        handleApproval("REJECT");
      } else if (status === "APPROVE") {
        handleApproval("APPROVE");
      }
    } else {
      toastr.error("Please select at least one Employer");
    }
  };
  const hasPendingEmployers = employersData.some(
    (emp) => emp.membershipStatus === "REQUEST"
  );

  if (loading) return <LoadingView message="Loading..." />;
  return (
    <div className="employerlist">
      <div className="searchRow studentTableSearch">
        <Search
          allowClear
          placeholder={`Find Employers`}
          onSearch={onSearch}
          enterButton
        />
        <Button
          icon={<ControlOutlined />}
          onClick={showModal}
          className="verficationSearchButton"
          type="primary"
        ></Button>
      </div>
      <div className="approval">
        {hasPendingEmployers && (
          <>
            <Button
              type="primary"
              className="button"
              onClick={() => handleAction("REJECT")}
            >
              Reject
            </Button>
            <Button
              type="primary"
              className="button"
              onClick={() => handleAction("APPROVE")}
            >
              Approve
            </Button>
          </>
        )}
      </div>

      {employersData.length > 0 ? (
        employersData.map((employerData) => (
          <div className="jobRow">
            <div style={{ display: "flex", alignItems: "center" }}>
              {employerData.membershipStatus === "REQUEST" && (
                <div
                  className="checkbox"
                  onClick={() => toggleSelectEmployer(employerData.id)}
                >
                  <Checkbox
                    checked={selectedEmployers.includes(employerData.id)}
                  />
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  marginLeft: 10,
                  cursor: "pointer",
                  // paddingRight: 300,
                }}
                onClick={() =>
                  navigate(`/EmpByID/${employerData.id}`, {
                    state: { eventId },
                  })
                }
              >
                <span className="card">
                  <img
                    src={employerData.profileUrl || defaultCompany}
                    alt="Profile"
                    width={40}
                    height={40}
                  />
                </span>

                <div className="jobsHead">
                  <div className="jobsHeadCol">
                    <h3>{employerData.name}</h3>
                    <ul>
                      <li>
                        <span className="JobInfo">
                          <span className="infoNameType">Phone</span>
                          <span className="infoNameValue">
                            {employerData.phone}
                          </span>
                        </span>
                      </li>
                      <li>
                        <span className="JobInfo">
                          <span className="infoNameType">Email</span>
                          <span className="infoNameValue">
                            {employerData.email}
                          </span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {employerData.membershipStatus == "APPROVE" ? (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <div className="approved">Approved</div>
                  <div className="approval">
                    <Button
                      type="primary"
                      className="button"
                      onClick={() =>
                        handleSingleRejection(employerData.id, "REJECT")
                      }
                    >
                      Reject
                    </Button>
                  </div>
                </div>
              </>
            ) : employerData.membershipStatus == "REJECT" ? (
              <div className="rejected">Rejected</div>
            ) : (
              <div className="requested">Requested</div>
            )}
          </div>
        ))
      ) : (
        <>
          <div className="errorMsg">
            <Image src={ErrorIcon} preview={false} />
            <h4>No Registered Employers</h4>
          </div>
        </>
      )}
      {/* <div className="paginationRow">
        <Pagination pageSize={20} total={employersData.length} />
      </div> */}

      {/* Confirmation Modal */}
      <Modal
        title={`Confirmation`}
        visible={confirmModalVisible}
        // onOk={confirmAction}

        onCancel={() => setConfirmModalVisible(false)}
        footer={[
          <Button
            key="no"
            onClick={() => setConfirmModalVisible(false)}
            style={{
              borderRadius: "7px",
              minWidth: "100px",
              height: "auto",
              fontSize: "16px",
              fontWeight: "400",
            }}
          >
            No
          </Button>,
          <Button key="yes" type="primary" onClick={confirmAction}>
            Yes
          </Button>,
        ]}
      >
        <p>Are you sure you want to {actionType.toLowerCase()}?</p>
      </Modal>

      <Modal
        title="Filters"
        visible={modalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk}>
            Ok
          </Button>,
        ]}
      >
        <Radio.Group
          onChange={(e) => setApprovalStatus(e.target.value)}
          value={approvalStatus}
        >
          <Radio value="all">All</Radio>
          <Radio value="approve">Approved</Radio>
          <Radio value="reject">Rejected</Radio>
          <Radio value="request">Pending</Radio>
        </Radio.Group>
      </Modal>
    </div>
  );
}

export default Employer;
